import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "text-center justify-content-center" }

import { onMounted, ref, unref } from 'vue';
import { useTenantSettingStore } from '@/store';
import { storeToRefs } from 'pinia';
import { TenantSettingsInterface } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureFlags',
  setup(__props) {

const tenantSettingsStore = useTenantSettingStore();
const { loading } = storeToRefs(tenantSettingsStore);

const settings = ref<TenantSettingsInterface[]>([]);
const enable = ref<boolean>(false);

const setSettings = async () => {
  settings.value = structuredClone(tenantSettingsStore.settings);
  settings.value.forEach((setting) => {
    setting.checked = setting.value === 1 ? true : false;
  });
};
const init = async () => {
  if (can([PERMISSIONS.TENANT_SETTINGS_UPDATE])) {
    await tenantSettingsStore.getTenantSettings();
    await setSettings();
  } else window.location.href = '/';
};

onMounted(() => {
  init();
});

const cancel = () => {
  enable.value = false;
  setSettings();
};

const save = async () => {
  const payload = unref(settings);

  payload.forEach(async (setting) => {
    await tenantSettingsStore.updateSettings(setting);
  });

  init();
};

const changeValue = (data: TenantSettingsInterface) => {
  enable.value = true;
  data.value = data.value === 1 ? 0 : 1;
};

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("h2", null, "Feature Flags", -1)
    ]))]),
    content: _withCtx(() => [
      (_unref(loading).settings)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "...loading"))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_DataTable, {
              scrollable: true,
              value: settings.value,
              "responsive-layout": "scroll",
              "scroll-height": "flex"
            }, {
              default: _withCtx(() => [
                (settings.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_Column, {
                        header: "Name",
                        field: "name",
                        "header-class": "required"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("span", {
                            class: "w-10 font-semibold",
                            textContent: _toDisplayString(data.name)
                          }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        class: "px-2 gap-2",
                        header: "Enable/Disable"
                      }, {
                        body: _withCtx(({ data }) => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_Checkbox, {
                              modelValue: data.checked,
                              "onUpdate:modelValue": ($event: any) => ((data.checked) = $event),
                              binary: true,
                              onChange: ($event: any) => (changeValue(data))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value"])
          ]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        disabled: !enable.value,
        text: "Save",
        type: "primary",
        onClick: save
      }, null, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})